import axios from "axios";

/// URL FOR GPT3 COMPLETIONS BACKEND
const SERVER_URL = "https://completions-backend-wo6lyw2p5q-uc.a.run.app/";
//const SERVER_URL = "http://localhost:49832/";

export const post = (endpoint, options = {}) => {
  return axios.post(SERVER_URL + endpoint, options);
};
